import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image } from '@platzi/ui';

import styles from './Course.module.sass';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';

export const Course = (props) => {
  const { t } = useTranslation();

  return (
    <a className={styles.Course} href={props.url}>
      <div className={styles.CourseInformation}>
        <Image src={props.badge_url} alt={props.title} />
        <div>
          <h3>{props.title}</h3>
          <p>
            {props.content_duration} {t('route.course.contentHours')} {props.practice_duration}{' '}
            {t('route.course.practiceHours')}
          </p>
        </div>
      </div>
      {props.is_approved && (
        <div className={styles.CourseProgressCont}>
          <FontAwesomeIcon icon={faBadgeCheck} />
          <p>{t('route.course.approved')}</p>
        </div>
      )}
    </a>
  );
};
